module.exports = __webpack_public_path__ + "img/9-10.363f7a6c.jpg";